export default function OneCardMeterRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 800px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    .modal-overlay {
                        position: fixed; 
                        top: 0;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        z-index: 9999;
                        overflow-y: auto;
                        }
                `}
            </style>
            {show && (
                <div className="modal-overlay">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>One Card Meter</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">The objective of the game is to predict which player will win based on the higher card value.</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b>1 Card meter will be played with 8 deck of cards.</b></p>
                                            <p class="pt20"><b>The value of the cards is as follows:</b></p>
                                            <p class="pt20">ACE = 1, 2 = 2, 3 = 3, 4 = 4, 5 = 5, 6 = 6, 7 = 7, 8 = 8, 9 = 9, 10 = 10, Jack = 11, Queen = 12, King = 13.</p>
                                            <p class="pt20">The two players will be named Player A &amp; Player B. Each Player will receive one card.</p>
                                            <p class="pt20">The winner will be the Player with the higher value card. If Player A has a card with a lower value, the point difference will be calculated to determine the winning amount.</p>
                                            <p class="pt20"><b>Example:</b></p>
                                            <p class="pt20">If Player A has a 7 and Player B has a King (13), Player B will win with a 6-point difference (13-7 = 6).</p>
                                            <p class="pt20"><b>Winning Amount Calculation:</b></p>
                                            <p class="pt20">The winning amount will be calculated based on the point difference, as follows:</p>
                                            <ul class="pt20">
                                                <li>1 point = 1 time bet amount</li>
                                                <li>2 points = 2 times bet amount</li>
                                                <li>3 points = 3 times bet amount</li>
                                                <li>... up to 12 points = 12 times bet amount (highest)</li>
                                            </ul>
                                            <p class="pt20">For example, if Player B wins by 6 points, their winning amount will be 6 times the bet amount. Player A will lose 6 times their bet amount.</p>
                                            <p class="pt20">If a punter places a bet of 100 and loses by 12 points, they will lose 1200 (100 * 12).</p>
                                            <p class="pt20">The maximum win or loss can be 12 times the bet amount.</p>
                                            <p class="pt20"><b>If both Players have the same value cards but different suits:</b></p>
                                            <p class="pt20">The winner will be decided by the ranking of the suits:</p>
                                            <p class="pt20">Order of suits: Spades, Hearts, Clubs, Diamonds.</p>
                                            <p class="pt20">For example, if Player A has a Clubs Ace and Player B has a Diamonds Ace, Player A wins because Clubs are ranked higher than Diamonds.</p>
                                            <p class="pt20">In this case, the winning amount will be 1 time the bet amount.</p>
                                            <p class="pt20"><b>If both Players have the same value cards and the same suits:</b></p>
                                            <p class="pt20">This results in a tie, and the bet amount will be refunded (pushed).</p>
                                        </div>

                                        <h3><b>Side Bets</b></h3>
                                        <p class="pt20"><b>Pair:</b> You can bet that both the player and dealer will have the same ranking cards, irrespective of suits.</p>
                                        <p class="pt20"><b>Tie:</b> You can bet that the game will be a tie.</p>
                                        <p class="pt20">
                                            <b>Note:</b> In case of a tie between the player and dealer, side bets will still be considered valid.
                                        </p>
                                    </center>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            )}
        </>
    );
}